import { useEffect, useRef } from 'react'

/** A ref for a scrolling area that jumps back to the top whenever any of `deps` changes (a new page, filter or view). */
export function useScrollReset<T extends HTMLElement>(deps: unknown[]) {
  const ref = useRef<T>(null)
  useEffect(() => {
    ref.current?.scrollTo({ top: 0 })
    // The caller's deps are the trigger; the ref is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
  return ref
}
